import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChildren, ComponentFactoryResolver, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { IEntityModel } from '@framework/interfaces/IEntityModel';
import { ViewType, FieldType } from '@framework/core/Enums';
import { FormBuilderControl, IFormFieldGroup } from '@common/formbuilder/FormBuilderControl';
import { IControlChangeEventArgs } from '@common/formbuilder/IControlChangeEventArgs';
import { ApiService } from '../../../services/api/api.service';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import { FormBuilderControlType } from '../../../common/formbuilder/FormBuilderControlType';
import { WindowService } from '@progress/kendo-angular-dialog';
import { UntypedFormControl, UntypedFormGroup, ControlContainer, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MfControlPopupComponent } from '../mf-control-popup/mf-control-popup.component';
import { now } from 'moment';
import { IYesNoFieldOptions, IButtonFieldOptions } from '../../interfaces/IEntity';
import { Moment } from 'moment';
import *  as moment from 'moment';
import { InputValidationService } from '../../../services/input-validation/input-validation.service';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { MFCustomDatetimePopupComponent } from './mfcustom-datetime-popup/mfcustom-datetime-popup.component';
import { ControlLookupCacheService } from '../../../services/control-lookup-cache/control-lookup-cache.service';
import { MfCustomSignatureComponent } from './mfcustom-signature/mfcustom-signature.component';
import { appStyleSettings, appSettings } from '@shared/components/appSettings';
import { MfMultiInstanceGridComponent } from './mf-multi-instance-grid/mf-multi-instance-grid.component';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';
import * as _ from 'underscore';
import { MFCustomInputPopupComponent } from './mfcustom-input-popup/mfcustom-input-popup.component';

@Component({
  selector: 'app-mf-form-control',
  templateUrl: './mf-form-control.component.html',
  styleUrls: ['./mf-form-control.component.css'],
  encapsulation: ViewEncapsulation.None,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  //changeDetection: ChangeDetectionStrategy.OnPush //Greatly helps with performance but have to be sure all change detection works or should be triggered itself when necessary https://netbasal.com/a-comprehensive-guide-to-angular-onpush-change-detection-strategy-5bac493074a4
})
export class MfFormControlComponent implements OnInit {
  public appStyleSettings = appStyleSettings;
  public appSettings = appSettings;
  public formGroup: UntypedFormGroup;
  public instance = this;
  private _htmlFormControl: UntypedFormControl;
  public get htmlFormControl() {
    if (this._htmlFormControl)
      return this._htmlFormControl;
    else {
      this._htmlFormControl = this.getHtmlFormControl();
      return this._htmlFormControl;
    }
  }
  @Input() public multiInstanceParentData: any;
  @Input() public controlsReadOnly: boolean = false;
  @Input() public displayLabel: boolean = true;
  @Input() public floatLabel: any = appStyleSettings.floatLabel;
  @Input() public appearance: any = appStyleSettings.formControlAppearance;
  @Input() public fieldGroup: IFormFieldGroup;
  @Input() public htmlFormGroup: UntypedFormGroup;
  @Input() public formReadOnly: boolean;
  @Input() public isFilters: boolean;
  @Input() public formControlPrefix: any;
  @Input() public disabled: boolean;
  @Input() public nestedParent: any;
  @Input() set dataObj(val) {
    this._dataObj = val;
    //if (this.formField && this.formField.controlType.viewType == ViewType.DateRange) {
    //  if (!val) {
    //    this._dataObj = { start: null, end: null };
    //  }
    //}
    this.dataObjChange.emit(val);
    if (this.customControlInstance) {
      this.customControlInstance.component.dataObj = this.dataObj;
    }
    //if (this.historyEnabled) {
    //  var field = this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField : this.formField.field;
    // if ( this.dataObj[field + '__datestamp'])
    //  this.dataObj[field + '__datestamp'] = new Date(this.dataObj[field + '__datestamp']);
    //}

    //this.htmlFormGroup.reset();
    //this.htmlFormGroup.markAllAsTouched();
  }
  @Input() public set formField(value: FormBuilderControl) {
    this._formField = value;

    if (this._formField && this._formField.lookups) {
      this.filteredLookups.next(this._formField.lookups.slice());
    }
    if (!this.formField.displayName) this.displayLabel = false;
    this._formField.formControl = this;

    if (this._formField.controlType.viewType == ViewType.Dropdown) {
      var _th = this;
      _th._formField.refreshLookups = function () {
        _th.refreshLookups();
        _th.cdr.detectChanges();
      }
    }
  }
  @Input() set parent(value) {
    this._parent = value;
  }
  @Input() public set data(value) {

    if (this.historyEnabled) {
      if (value == null || value == "")
        this.addingNewHistory = true;
    }
    if (!this.formField)
      return;
    if (this.formField.controlType.viewType == ViewType.MultiSelect) {
      //remove the flattened
      for (let key in this.dataObj) {
        if (key.startsWith(this.formField.field + "___", 0)) {
          delete this.dataObj[key];
        }
      }
      if (!value) {

        value = new Array();
        if (this.dataObj) this.dataObj[this.formField.field] = new Array();
      }
    }
    if (this.formField.controlType.viewType == ViewType.DateRange) {
      if (!value) {
        this.dataObj = { start: null, end: null };
      }
    }
    else if (this.formField.controlType.viewType == ViewType.Pictures) {
      this.setGalleryImages(value)
    }
    else if (this.formField.controlType.viewType == ViewType.MultipleInstance) {
      this.multiInstanceFormFields = new Array();

      this._data = value;
      if (this._data) {
        this._data.forEach(o => {
          var formFields = new Array()
          this.formField.fieldOptions.instanceFields.forEach(o => {
            let field = new FormBuilderControl().load(o);

            let displayName: string = this.formField.formControl.parent && this.formField.formControl.parent.parent ? this.authService.fieldLabelName(this.formField.formControl.parent.parent.form.name, field.field) : null;
            if (displayName) field.displayName = displayName;
            formFields.push(field);
          })
          this.multiInstanceFormFields.forEach(z => {
            z.expanded = false;
          })
          this.multiInstanceFormFields.push({ formFields: formFields, expanded: true, instance: o.instance })
        })
      }
    }
    else {
      let old = this._data;
      this._data = value;
      this.dataChange.emit(value);
      if (this.formField.fieldOptions && this.formField.fieldOptions.change && old != this._data)
        this.formField.fieldOptions.change(old, this._data, this.dataObj, this, this.formField.fieldOptions);
      if (this.customControlInstance) {
        this.customControlInstance.component.data = this.data;
      }
    }
    if (this.formField.controlType.viewType == ViewType.AutoComplete || (this.formField.controlType.viewType == ViewType.Dropdown && this.formField.fieldOptions != null && this.formField.fieldOptions.searchEndPoint)) {
      if (value != '' && value != null && !value.value)
        this.getInitialAutoCompleteValue(value);


    }

    if (value != '' && value != null && !value.value)
      if (this.formField?.fieldOptions?.allowOther && this.formField?.lookups?.length > 0)
        this.getOtherLookupValue();

    if ((this.formField && this.formField.disableLookupCache) || (this.formField.fieldOptions && this.formField.fieldOptions.disableLookupCache)) {
      this.setupDropdowns()
    }
    if (this.formField && this.formField.lookups)
      this.filteredLookups.next(this._formField.lookups.slice());
    if (this._windowRefInstance)
      this._windowRefInstance.data = value;
    if (!this.data)
      this.expanded = true;
    else this.expanded = false;
    var hasLoad: any = this.formField.fieldOptions;
    if (hasLoad && hasLoad.load) {
      hasLoad.load(this);
    }
    this.checkMinMax();


    if (this.pendingChangesEnabled && this.dataObj[this.formField.fieldOptions.pendingChangesProperty]) {
      this.dataObj[this.formField.fieldOptions.pendingChangesProperty][this.formField.field] = value;
    }
  }

  public getOtherLookupValue() {
    var self = this;
    if (self.data && self.formField?.fieldOptions?.allowOther) {
      if (self.formField.lookups.filter((q) => q.value == self.data).length == 0) {
        self.apiService.get('/api/lookupValue/' + self.data).subscribe(o => {
          this.formField.lookups.push({ value: self.data, label: o.name, cascadeValue: null });
          this.filteredLookups.next(this.formField.lookups);
        }, err => {
          this.formField.lookups.push({ value: self.data, label: self.data, cascadeValue: null });
          this.filteredLookups.next(this.formField.lookups);

        })
      }
    }
  }

  public statusClick(data) {
    event.stopPropagation();
    if (this.formField.fieldOptions.canClick) {
      if (!this.formField.fieldOptions.canClick(this, data))
        return;
    }
    this.data = data;
    this.onControlDataChange.emit({ formBuilderControl: this.formField, controlValue: this.data, extraData: this.extraData, context: this });
  }

  public get pendingChangesEnabled() {
    return this.formField && this.formField.fieldOptions && this.formField.fieldOptions.pendingChangesProperty && this.dataObj;
  }
  public get pendingChanges() {
    if (this.pendingChangesEnabled) {
      if (this.dataObj[this.formField.fieldOptions.pendingChangesProperty] && this.dataObj[this.formField.fieldOptions.pendingChangesProperty][this.formField.field]) {
        var pendingChange = this.dataObj[this.formField.fieldOptions.pendingChangesProperty][this.formField.field];
        if (pendingChange != this.data) {
          if (this.formField.controlType?.viewType == ViewType.Dropdown && this.formField.lookups) {
            var pendingLookupChange = this.formField.lookups.filter(o => o.value == pendingChange);
            if (pendingLookupChange.length > 0)
              pendingChange = pendingLookupChange[0].label;
          }
          return `Pending Change: <strong>${pendingChange}</strong> by ${this.dataObj[this.formField.fieldOptions.pendingChangesProperty]['changedByUsername']} on ${this.dataObj[this.formField.fieldOptions.pendingChangesProperty]['datestamp']}`
        }
      }
    }
  }

  public test(e) {
    debugger;
  }
  @Input() extraData: any;

  @Output() public dataChange = new EventEmitter();
  @Output() public dataObjChange = new EventEmitter();
  @Output() public onControlDataChange = new EventEmitter<IControlChangeEventArgs>();

  @ViewChild("windowContainer", { read: ViewContainerRef, static: true }) public windowContainerRef: ViewContainerRef;
  @ViewChild('customControl', { static: true, read: ViewContainerRef }) customControlTarget: ViewContainerRef;
  @ViewChild('signatureControl', { static: true, read: ViewContainerRef }) public signatureControl: ViewContainerRef;
  public get dateData() {
    if (this.data) {
      if (typeof this.data == 'string') {

        var now = new Date(this.data);
        return moment(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())).toDate();// new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes()));
      }
      else if (moment.isMoment(this.data))
        return this.data.toDate();
      else return this.data;
    }
  }
  public set dateData(val) {
    if (!val) return;
    this.data = new Date(Date.UTC(val.getFullYear(), val.getMonth(), val.getDate()));
    this.triggerDirty(null,null)
  }

  public get dateTimeData() {
    if (this.data) {
      if (typeof this.data == 'string') {
        var now = new Date(this.data);
        return moment(now).toDate();// new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes()));
      }
      else if (moment.isMoment(this.data))
        return this.data.toDate();
      else return this.data;
    }
  }
  public set dateTimeData(val) {

    if (!val) return;
    this.data = val;// new Date(val.getFullYear(), val.getMonth(), val.getDate(), val.getHours(), val.getMinutes());
  }
  public multiInstanceDataChange = new EventEmitter();
  protected _onDestroy = new Subject<void>();
  private previousDropdownUrl: any;
  private _windowRef: any;
  private _windowRefInstance: any;
  private _formField: FormBuilderControl;
  private _data: any = {};
  private _dataObj: any;
  public filteredLookups: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  _parent: any;
  self: any = this;
  public get formControlName() {
    var control = (this.fieldGroup ? this.fieldGroup.name : '') + (this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField : this.formField.field);
    return (this.formControlPrefix != null ? this.formControlPrefix + control : control);
  }
  public multiInstanceFormFields: any;
  public addingNewHistory: boolean = false;
  public historyVisible: boolean = false;
  private _validationWarning: any = null;
  public set validationWarning(value) {
    var changed = this._validationWarning != value;
    this._validationWarning = value;
    if (this.formField.fieldOptions)
      this.formField.fieldOptions.validationWarning = value;
    if (changed)
      this.cdr.detectChanges();
  }
  public get validationWarning() {
    return this._validationWarning;

  }
  private _validationMessage: any = null;
  public set validationMessage(value) {
    var changed = this._validationMessage != value;
    if (this.htmlFormControl) {
      if (value) {
        this.htmlFormControl.setErrors({ 'incorrect': true });
        this.htmlFormControl.markAsTouched();
        this.htmlFormControl.markAsDirty();
      }
      else {
        if (!this.htmlFormControl.valid) {
          this.htmlFormControl.setErrors(null);
        }
      }
    }
    this._validationMessage = value;
    if (this.formField.fieldOptions)
      this.formField.fieldOptions.validationMessage = value;
    if (changed)
      this.cdr.detectChanges();
  }
  public get validationMessage() {
    return this._validationMessage;

  }
  public get formField(): FormBuilderControl { return this._formField; }
  public get fieldDisabled() {
    if (this.disabled)
      return true;
    if (this.notApplicable)
      return true;
    if (this.controlsReadOnly)
      return true;
    if (this.isFilters)
      return false;
    if (!this.formField)
      return true;
    if (this.formField.disabled)
      return true;
    if (this.historyEnabled) {
      return !this.addingNewHistory
    }
    if (this.formField.fieldOptions && this.formField.fieldOptions.readOnly) {
      if ({}.toString.call(this.formField.fieldOptions.readOnly) === '[object Function]') {
        let test: any = this.formField.fieldOptions.readOnly;
        return test(this.data, this.parent.parent, this.formField)
      }
      else return this.formField.fieldOptions.readOnly;
    }
  }
  public get fieldDisabledExclNa() {
    if (this.controlsReadOnly)
      return true;
    if (this.isFilters)
      return false;
    if (!this.formField)
      return true;
    if (this.formField.disabled)
      return true;
    if (this.historyEnabled) {
      return !this.addingNewHistory
    }
    if (this.formField.fieldOptions && this.formField.fieldOptions.readOnly) {
      if ({}.toString.call(this.formField.fieldOptions.readOnly) === '[object Function]') {
        let test: any = this.formField.fieldOptions.readOnly;
        return test(this.data, this.parent.parent, this.formField)
      }
      else return this.formField.fieldOptions.readOnly;
    }
  }
  public get fieldRequired() {
    if (!this.formField.fieldOptions)
      return false;
    var anyRequired: any = this.formField.fieldOptions.required;
    if ({}.toString.call(anyRequired) === '[object Function]')
      return anyRequired(this.dataObj, this.authService, this);
    else return anyRequired;
  }
  public get historyData() {
    var field = this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField + '__history' : this.formField.field + '__history';
    return this.dataObj[field] ? this.dataObj[field].sort(function (a, b) { return a.instance > b.instance ? -1 : 1 }) : [];
  }
  public get data() {
    return this._data;
  }
  public get labelDisplay() {
    if (this.linkDisplay || this.downloadDisplay || this.customControlInstance || this.galleryDisplay)
      return false;
    else return true;
  }
  public get linkDisplay() {
    if (this.formField.controlType.viewType == ViewType.Link)
      return true;
    else return false;
  }
  public get downloadDisplay() {
    if (this.formField.controlType.viewType == ViewType.File ||
      this.formField.controlType.viewType == ViewType.Signature)
      return true;
    else return false;
  }
  public get historyEnabled() {
    if (this.formField && this.formField.fieldOptions)
      return this.formField.fieldOptions.historyEnabled;
    else return false;
  }
  public get galleryDisplay() {
    if (
      this.formField.controlType.viewType == ViewType.Pictures)
      return true;
    else return false;
  }
  public get getLinkValue() {
    if (this.data)
      if (this.data.indexOf("http") == -1)
        return 'http://' + this.data;
    return this.data;
  }
  public get getDisplayValue() {
    var self = this;
    if ((this.formField.controlType.viewType == ViewType.Dropdown || this.formField.controlType.viewType == ViewType.MultiSelect) && this.formField.lookups) {
      var value = this.formField.lookups.filter(function (o) {
        return o.value == self.data;
      });
      if (value.length > 0)
        return value[0].label;
      return "";
    }
    if (this.formField.controlType.viewType == ViewType.AutoComplete) {
      return this.dataAutoComplete ? this.dataAutoComplete.label : "";
    }
    if (this.formField.controlType.viewType == ViewType.YesNo) {
      return this.data == true ? "Yes" : "No";
    }
    return this.data;
  }
  get dataObj() {
    return this._dataObj;
  }
  get parent() {
    return this._parent;
  }
  public get notApplicable() {
    return this.data == "N/A";
  }
  public set notApplicable(val) {
    this.data = val ? "N/A" : "";
  }
  public windowState: any = 'minimized';
  public loadingProgress: boolean;
  public showUpload: boolean = false;
  public dataAutoComplete: any;
  @Input()
  public loading: boolean = false;
  public dropDownSearching: boolean = false;

  public customControlInstance: any;
  public uploadingFileCount: number = 0;
  public viewType = ViewType;
  public galleryImages: any;
  public expanded: boolean = false;
  public authService: IdentityAuthService;
  public searchText: string = "";
  public searchTextChanged: Subject<string> = new Subject<string>();
  autoCompleteControl = new UntypedFormControl();

  constructor(public apiService: ApiService, private componentFactoryResolver?: ComponentFactoryResolver, public messageService?: ToastrService, private _authService?: IdentityAuthService,
    public cdr?: ChangeDetectorRef, public dialogService?: MatDialog, private controlContainer?: ControlContainer, private inputValidationService?: InputValidationService, public controlLookupCache?: ControlLookupCacheService
    , public nestedNav?: NestedNavigationService) {
    this.authService = _authService;


  }

  public controlDataChange(formBuilderControl: FormBuilderControl, value: any) {
    if (typeof value != "undefined")
      this.onControlDataChange.emit({ formBuilderControl: formBuilderControl, controlValue: value, extraData: this.extraData, context: this });
  }
  public checkChanges() {
    this.cdr.detectChanges();
  }
  public search(val, formField: FormBuilderControl, data) {
    if (this.formField.fieldOptions.dontForceAutoCompleteSelect)
      this.dataObj[this.formField.field] = val;
    this.loadingProgress = true;
    if (this.extraData?.usePost) {
      this.apiService.post(formField.fieldOptions.searchEndPoint.url, { query: val })
        .subscribe(items => {

          this.loadingProgress = false;
          formField.lookups = items.map(o => { return { value: o[formField.fieldOptions.dataIdField], label: o[formField.fieldOptions.dataDisplayField], data: o } })
          this.cdr.detectChanges();
        }, error => { this.loadingProgress = false; });

    }
    else {
      this.apiService.get(formField.fieldOptions.searchEndPoint.url + encodeURIComponent(val))
        .subscribe(items => {

          this.loadingProgress = false;
          formField.lookups = items.map(o => { return { value: o[formField.fieldOptions.dataIdField], label: o[formField.fieldOptions.dataDisplayField], data: o } })
          this.cdr.detectChanges();
        }, error => { this.loadingProgress = false; });

    }
  }
  public getInitialAutoCompleteValue(val) {
    if (!this.formField.lookups)
      this.formField.lookups = new Array();

    if (this.formField.lookups.filter(o => o.value == val).length > 0)
      return;

    if (!this.formField.fieldOptions.dataEndPoint) {

      this.formField.lookups.push({ value: val, label: val, cascadeValue: null });
      this.filteredLookups.next(this.formField.lookups);
      this.cdr.detectChanges();

      return;
    }
    this.formField.disabled = true;
    var temp = this.formField.displayName;
    this.formField.displayName = 'Loading...';

    var hasCached = false;
    if ((this.formField && !this.formField.disableLookupCache) || (this.formField.fieldOptions && !this.formField.fieldOptions.disableLookupCache)) {
      var hasCachedValue = this.controlLookupCache.getCachedLookups(this.formField.fieldOptions.dataEndPoint.url + val, this.formField);
      if (hasCachedValue) {
        this.filteredLookups.next(this.formField.lookups.slice());
        hasCached = true;
      }
    }
    if (!hasCached) {
      this.apiService.get(this.formField.fieldOptions.dataEndPoint.url + val)
        .subscribe(o => {
          this.formField.disabled = false;
          this.formField.displayName = temp;
          var idField = 'id';
          var displayField = 'name';
          var cascadeField = 'parentId';
          if (this.formField.fieldOptions.dataIdField)
            idField = this.formField.fieldOptions.dataIdField;
          if (this.formField.fieldOptions.dataDisplayField)
            displayField = this.formField.fieldOptions.dataDisplayField;
          if (this.formField.fieldOptions.dataCascadeField) {
            cascadeField = this.formField.fieldOptions.dataCascadeField;
          }
          if (o) {
            this.formField.lookups.push({ value: o[idField], label: o[displayField], cascadeValue: o[cascadeField], dataItem: o })
            this.filteredLookups.next(this.formField.lookups.slice());

            this.controlLookupCache.setCachedLookups(this.formField.fieldOptions.dataEndPoint.url + val, this.formField)
          }
          //this.dataAutoComplete = { value: val, label: item[this.formField.fieldOptions.dataDisplayField] };
          //if (this.formField.fieldOptions && this.formField.fieldOptions.change)
          //  this.formField.fieldOptions.change(null, item, this.dataObj, this);
          // this.cdr.detectChanges();

        }, error => {
          this.formField.disabled = false;
          this.formField.displayName = temp;
          this.formField.lookups.push({ value: val, label: val, cascadeValue: null });
          this.filteredLookups.next(this.formField.lookups);
          this.cdr.detectChanges();
        });
    }
    else {

      this.formField.disabled = false;
      this.formField.displayName = temp;
    }
  }

  public clearCachedLookups() {
    this.controlLookupCache.clearCachedLookups(this.formField);
  }


  public removeGalleryImage(item) {
    this.dataObj[this.formField.field].splice(this.dataObj[this.formField.field].indexOf(item), 1);
    this.setGalleryImages(this.dataObj[this.formField.field])
  }
  public setGalleryImages(value) {

    this.galleryImages = [];
    if (value && value.length > 0) {
      value.forEach(o => {
        this.galleryImages.push({ source: `${this.formField.fieldOptions.dataEndPoint.url}/${o}`, id: o });
      })
    }
    var _th = this;
    if (this.dataObj['mainFileCabinetDocumentId']) {
      var defaultImg = this.galleryImages.filter(function (i) {
        return i.id == _th.dataObj['mainFileCabinetDocumentId']
      });
      if (defaultImg.length > 0) {
        defaultImg[0].default = true;
        _th.galleryImages.splice(_th.galleryImages.indexOf(defaultImg[0]), 1);
        _th.galleryImages.unshift(defaultImg[0])
      }
    }
  }
  public setDefaultImage(value) {
    this.galleryImages.forEach(o => {
      o.default = false;
    });
    value.default = true;
    this.dataObj['mainFileCabinetDocumentId'] = value.id;
  }
  public downloadFile(id, name?) {
    this.loading = true;
    let endPoint: string = this.formField.fieldOptions.dataEndPoint.url + id;
    this.apiService.downloadFile(endPoint)
      .subscribe(respData => {
        var blob = new Blob([respData]);
        this.apiService.saveFile(blob, name ? name : this.data.name);
        this.loading = false;
        this.cdr.detectChanges();
      }, error => {
        this.loading = false;
        this.cdr.detectChanges();
        console.log('err');
      });

  }
  public triggerDirty(inputYesNo, e) {
    if (this.parent && this.parent.parent) {
      var control = this.htmlFormControl;
      if (control)
        control.markAsDirty();
    }
    if (e)
      e.stopPropagation();
  }
  public checkboxClick(e) {
    if (this.fieldDisabled)
      return;
    if (e)
      e.stopPropagation();
    this.controlDataChange(this.formField, !this.data);
  }
  public triggerPristine() {
    if (this.parent && this.parent.parent) {
      var control = this.htmlFormControl;
      if (control)
        control.markAsPristine();
    }
  }

  public getFormControl(name) {
    var self = this;
    if (self.parent && self.parent.parent && self.parent.parent.getFormControl) {
      var control = self.parent.parent.getFormControl(name);
      return control;
    }
  }
  public getHtmlFormControl() {
    var self = this;
    if (self.parent && self.parent.parent && self.parent.parent.getFormControl) {
      var control = self.parent.parent.getFormControl(self.formControlName);
      return control;
    }
  }
  public addNewComponent() {

    //const ref = this.dialogService.open(this.formField.fieldOptions.canAddNewComponent, {
    //  disableClose:true,
    //  width: '50%',
    //  data: {
    //    parent: this
    //  }
    //});
    //ref.onClose.subscribe((newId) => {
    //  debugger;
    //  if (newId) {
    //    this.data = newId;
    //    if (this.formField.controlType.viewType == ViewType.AutoComplete) {
    //      this.dataObj[this.formField.field] = newId;
    //      this.getInitialAutoCompleteValue(newId);

    //    } 
    //  }
    //});
  }
  //handleFilter(value) {
  //  if (value == null || value == "")
  //    this.filteredLookups = this.formField.lookups;
  //  else
  //    this.filteredLookups = this.formField.lookups.filter((s) => s.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  //}
  public setupDropdowns() {
    var self = this;
    if (self.formField.fieldOptions.dataEndPoint && !self.formField.fieldOptions.searchEndPoint) {
      var hasCached = false
      if ((self.formField && !self.formField.disableLookupCache) || (self.formField.fieldOptions && !self.formField.fieldOptions.disableLookupCache)) {
        var hasCachedValue = self.controlLookupCache.getCachedLookups(self.formField.fieldOptions.dataEndPoint.url, self.formField);
        if (hasCachedValue) {
          self.filteredLookups.next(self.formField.lookups.slice());
          hasCached = true;
        }
      }
      if (!hasCached) {
        if ((self.formField && self.formField.disableLookupCache) || (self.formField.fieldOptions && self.formField.fieldOptions.disableLookupCache)) {
          let url: string = {}.toString.call(self.formField.fieldOptions.dataEndPoint.url) === '[object Function]' ? self.formField.fieldOptions.dataEndPoint.url({ endPoint: self.formField.fieldOptions.dataEndPoint, context: self }, self) : self.formField.fieldOptions.dataEndPoint.url;
          if (self.previousDropdownUrl == url)
            return;
          self.previousDropdownUrl = url;
        }

        //if (typeof (self.formField.fieldOptions.dataEndPoint.url) == "function") {
        self.formField.disabled = true;
        var temp = self.formField.displayName;
        self.formField.displayName = 'Loading...';

        self.apiService.exec({
          endPoint: self.formField.fieldOptions.dataEndPoint,
          context: self,
          success: function (items) {
            var idField = 'id';
            var displayField = 'name';
            var cascadeField = 'parentId';
            self.formField.disabled = false;
            self.formField.displayName = temp;
            if (self.formField.fieldOptions.dataIdField)
              idField = self.formField.fieldOptions.dataIdField;
            if (self.formField.fieldOptions.dataDisplayField)
              displayField = self.formField.fieldOptions.dataDisplayField;
            if (self.formField.fieldOptions.dataCascadeField) {
              cascadeField = self.formField.fieldOptions.dataCascadeField;

            }
            self.formField.lookups = items.map(o => { return { value: o[idField], label: o[displayField], cascadeValue: o[cascadeField], dataItem: o } })
            self.filteredLookups.next(self.formField.lookups.slice());
            self.controlLookupCache.setCachedLookups(self.formField.fieldOptions.dataEndPoint.url, self.formField)
            self.cdr.detectChanges();
            if (self.data && self.formField?.fieldOptions?.allowOther) {
              self.getOtherLookupValue();
            }
          },
          error: function (error) {

            self.formField.disabled = false;
            self.formField.displayName = temp;
            self.cdr.detectChanges();
            self.messageService.error('error', 'Could not load: ' + self.formField.field);
          }

        })
      }
    }
  }
  public ngOnInit() {
    //if (this.formField && this.formField.fieldOptions.displayAsWindow && this.parent && this.parent.parent && this.parent.parent.parent && this.parent.parent.parent.windowContainerRef) {
    //  if (!this._windowRef) {
    //    this._windowRef = this.windowService.open({
    //      title: this.formField.displayName,
    //      content: MfFormControlComponent,
    //      width: 250,
    //      appendTo: this.parent.parent.parent.windowContainerRef
    //    });

    //    this._windowRefInstance = this._windowRef.content.instance;
    //    this._windowRefInstance._formField = this.formField;
    //    this._windowRefInstance.data = this.data;
    //  }
    //}
    this.formGroup = <UntypedFormGroup>this.controlContainer.control;

    if (!this.formField) {
      return;
    }
    let self: MfFormControlComponent = this;
    if (self.formField.fieldOptions && self.formField.fieldOptions.dataEndPoint && self.formField.fieldOptions.viewType != ViewType.File && self.formField.fieldOptions.viewType != ViewType.Button && self.formField.fieldOptions.viewType != ViewType.MultiSelect && self.formField.controlType.viewType != ViewType.RadioButton) {
      self.formField.controlType.viewType = ViewType.Dropdown;
    }
    if ((self.formField.controlType.viewType == ViewType.Dropdown || self.formField.controlType.viewType == ViewType.MultiSelect || self.formField.controlType.viewType == ViewType.RadioButton) && self.formField.fieldOptions) {
      self.setupDropdowns();
    }
    else if (self.formField.controlType.viewType == ViewType.CustomControl) {
      let component = self.formField.customControl;
      if (component) {
        let widgetComponent = self.componentFactoryResolver.resolveComponentFactory(component);
        let componentRef: any = self.customControlTarget.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.parent = self;
        _component.formField = self.formField;
        _component.data = self.data;
        _component.dataObj = self.dataObj;
        _component.formReadOnly = self.formReadOnly;
        if (_component.dataChange)
          _component.dataChange.subscribe(o => {
            self.data = o
          })
        if (_component.dataObjChange)
          _component.dataObjChange.subscribe(o => {
            self.dataObj = o
          })
        self.customControlInstance = { componentDetail: component, component: _component };
      }
    }
    else if (self.formField.controlType.viewType == ViewType.Pictures) {
      if (self.formField.fieldOptions.dataEndPoint) {
        self.apiService.get(self.formField.fieldOptions.dataEndPoint.url)
          .subscribe(items => {
            self.data = items.map(o => { return { pictureUrl: o[self.formField.fieldOptions.dataDisplayField], id: o[self.formField.fieldOptions.dataIdField] } })

            self.cdr.detectChanges();
          }, error => { });
      }
    }

    if (self.formField.controlType.viewType == ViewType.Dropdown || self.formField.controlType.viewType == ViewType.MultiSelect) {
      var debounceTimeSetup = 0;
      var showLoading = false;
      if (self.formField.fieldOptions && self.formField.fieldOptions.searchEndPoint) {
        debounceTimeSetup = 400;
        showLoading = true;
      }
      self.searchTextChanged
        .pipe(
          tap(() => self.dropDownSearching = showLoading),
          debounceTime(debounceTimeSetup), distinctUntilChanged())
        .subscribe(model => {
          self.filterLookups(model);
        });
    }
  }
  public onAutocompleteSelect(value, data) {
    this.dataObj[this.formField.field] = value.value;
    this.dataAutoComplete = value;
    if (this.formField.fieldOptions && this.formField.fieldOptions.change)
      this.formField.fieldOptions.change(null, value, this.dataObj, this);
    //this.cdr.detectChanges();
  }
  public onBeforeSend(event) {
    this.formField.blockSaving = true;
    //event.xhr.setRequestHeader("Authorization", `Bearer ${this.authService.access_token}`);
  }
  public onBeforeSendMulti(event) {
    this.uploadingFileCount += 1;
    this.formField.blockSaving = true;
    //event.xhr.setRequestHeader("Authorization", `Bearer ${this.authService.access_token}`);
  }
  public onProgress(event) {

  }
  public onUploadErrorMulti(event) {
    this.uploadingFileCount -= 1;
    if (this.uploadingFileCount == 0)
      this.formField.blockSaving = false;
  }
  public onUploadError(event) {

    this.formField.blockSaving = false;
  }
  public onUpload(event) {
    this.formField.blockSaving = false;
    this.data = {
      id: event.originalEvent.body.replace("\"", "").replace("\"", ""), name: event.files[0].name
    };
    this.dataObj[this.formField.fieldOptions.dataIdField] = this.data.id;
  }
  public onUploadMulti(event) {
    this.uploadingFileCount -= 1;
    if (this.uploadingFileCount == 0)
      this.formField.blockSaving = false;
    var res = event.originalEvent.body;
    if (!this.dataObj[this.formField.field])
      this.dataObj[this.formField.field] = new Array();
    res.forEach(o => {
      this.dataObj[this.formField.field].push(o);
    })
    this.setGalleryImages(this.dataObj[this.formField.field])
  }
  onDataChange(value) {
    this.data = this.dataObj;
    this.dataChange.emit(this.data);
  }

  public addNewHistoryData() {

    this.addingNewHistory = true;
    var newHistValue = this.data;

    var field = this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField : this.formField.field;

    var instance = typeof this.dataObj[field + "__instance"] != "undefined" ? this.dataObj[field + "__instance"] : -1;
    if (this.data == null || this.data == "")
      return;
    this.data = "";
    // var maxInstance = 0;

    //var lastItem = this.historyData.sort(function (a, b) { return a.instance > b.instance ? -1 : 1 })[0];
    //if (typeof lastItem != "undefined" && lastItem != null) {
    //  maxInstance = lastItem.instance;
    //}

    //
    if (!this.dataObj[field + '__history'])
      this.dataObj[field + '__history'] = new Array();
    var existsInHistory = this.dataObj[field + '__history'].filter(o => {
      return o.instance == instance
    });
    if (existsInHistory.length == 0 && newHistValue != null && newHistValue != "") {
      this.dataObj[field + "__instance"] = instance + 1;
      var date = null;
      if (this.dataObj[field + "__datestamp"])
        date = this.dataObj[field + "__datestamp"]
      this.dataObj[field + '__history'].push({
        instance: instance,
        value: newHistValue,
        datestamp: date,
        questionnaireItemPropertyItemId: this.formField.field
      })
    }
    else {
      instance += 1;
      this.dataObj[field + "__instance"] = instance;
    }
    this.dataObj[field + "__datestamp"] = null;
    //var date = now();
    //if (this.dataObj[field + "___datestamp"])
    //  date = this.dataObj[field + "___datestamp"];
    //var instance = this.dataObj[field + '___history'].length +1;
    //if (this.dataObj[field + "___instance"])
    //  instance = this.dataObj[field + "___instance"];
    //this.dataObj[field + '___history'].push({ datestamp: date, instance: instance, value: newHistValue });

  }

  public get historyDatestamp() {
    return this.dataObj[(this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField : this.formField.field) + '__datestamp'];
  }
  public set historyDatestamp(value) {
    this.dataObj[(this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField : this.formField.field) + '__datestamp'] = value;
  }

  public addNewInstance() {
    if (this.formField.fieldOptions.instanceFields) {
      if (!this.dataObj[this.formField.field]) this.dataObj[this.formField.field] = new Array();
      this.data = this.dataObj[this.formField.field];
      if (!this.multiInstanceFormFields) this.multiInstanceFormFields = new Array();
      var formFields = new Array()
      this.formField.fieldOptions.instanceFields.forEach(o => {
        let field = new FormBuilderControl().load(o);
        let displayName: string = this.authService.fieldLabelName(this.formField.formControl.parent.parent.form.name, field.field);
        if (displayName) field.displayName = displayName;
        formFields.push(field);
      })
      this.multiInstanceFormFields.forEach(o => {
        o.expanded = false;
      })
      var maxInstance = 0
      this.data.forEach(o => {
        if (o.instance > maxInstance)
          maxInstance = o.instance;
      })
      var dataLength = this.data.length;
      this.data.push({ sortOrder: dataLength + 1, data: {}, instance: maxInstance + 1 });
      this.multiInstanceFormFields.push({ formFields: formFields, expanded: true, instance: maxInstance + 1 })

      this.multiInstanceDataChange.emit();
    }


  }

  public deleteInstance(instance, index) {
    var flattenedToRemove = Object.keys(this.dataObj).filter(key => {
      //get flattened data
      return key.indexOf(this.formField.field + "___" + index + "___") != -1
    })
    flattenedToRemove.forEach(u => {
      delete this.dataObj[u];
    })
    this.multiInstanceFormFields.splice(this.multiInstanceFormFields.indexOf(instance), 1);
    //var indexFilt = this.data.filter(o => {
    //  return o.instance == instance.instance
    //});
    //if (indexFilt.length > 0)
    this.data.splice(index, 1);

    this.multiInstanceDataChange.emit();
  }

  public yesNoLabelClick(e) {

    if (!this.fieldDisabled && this.formField.fieldOptions && !(<IYesNoFieldOptions>this.formField.fieldOptions).disableYesNoClickLabel) {
      this.data = !this.data;
      this.triggerDirty(null, e)
    }
  }

  public buttonClick(e) {
    if (e)
      e.stopPropagation();

    if (this.formField && this.formField.fieldOptions) {
      let btnFld: IButtonFieldOptions = (<IButtonFieldOptions>(this.formField.fieldOptions));
      if (btnFld.click) btnFld.click(this);
      if (btnFld.action) btnFld.action(this);
    }
  }

  public checkMinMax() {
    var valid = true;
    var validationMessage = null;
    if (!this.data || !this.formField.fieldOptions || (this.formField.fieldOptions.minValue == undefined && this.formField.fieldOptions.maxValue == undefined)) return;
    var minValue = null;
    var maxValue = null;
    if (this.formField.controlType.viewType == ViewType.DateTime) {
      if (this.formField.fieldOptions.minValue) {
        if ({}.toString.call(this.formField.fieldOptions.minValue) === '[object Function]') {
          let test: any = this.formField.fieldOptions.minValue;
          minValue = test(this.data, this.dataObj)
        }
        else minValue = this.formField.fieldOptions.minValue;
        if (minValue) {
          if (moment(new Date(this.data)).isBefore(moment(minValue))) {
            validationMessage = this.formField.fieldOptions.minValueMessage ? this.formField.fieldOptions.minValueMessage : "Invalid date - must be larger than " + minValue;
            valid = false;
          }
        }
      }
      if (this.formField.fieldOptions.maxValue) {
        if ({}.toString.call(this.formField.fieldOptions.maxValue) === '[object Function]') {
          let test: any = this.formField.fieldOptions.maxValue;
          maxValue = test(this.data, this.dataObj)
        }
        else maxValue = this.formField.fieldOptions.maxValue;
        if (maxValue) {
          if (moment(new Date(this.data)).isAfter(moment(maxValue))) {
            validationMessage = this.formField.fieldOptions.maxValueMessage ? this.formField.fieldOptions.maxValueMessage : "Invalid date - must be smaller than " + maxValue;
            valid = false;
          }
        }
      }
    }
    else {
      if (this.formField.fieldOptions.minValue != undefined) {
        if ({}.toString.call(this.formField.fieldOptions.minValue) === '[object Function]') {
          let test: any = this.formField.fieldOptions.minValue;
          minValue = test(this.data, this.dataObj)
        }
        else minValue = this.formField.fieldOptions.minValue;
        if (minValue) {
          if (this.data < minValue) {
            validationMessage = this.formField.fieldOptions.minValueMessage ? this.formField.fieldOptions.minValueMessage : "Invalid value - must be greater than/equal to " + minValue;
            valid = false;
          }
        }
      }
      if (this.formField.fieldOptions.maxValue != undefined) {
        if ({}.toString.call(this.formField.fieldOptions.maxValue) === '[object Function]') {
          let test: any = this.formField.fieldOptions.maxValue;
          maxValue = test(this.data, this.dataObj)
        }
        else maxValue = this.formField.fieldOptions.maxValue;
        if (maxValue) {
          if (this.data > maxValue) {
            validationMessage = this.formField.fieldOptions.maxValueMessage ? this.formField.fieldOptions.maxValueMessage : "Invalid value - must be less than/equal to " + maxValue;
            valid = false;
          }
        }
      }
    }
    var self = this;
    //after view loaded
    setTimeout(function () {
      if (valid)
        self.validationMessage = null;
      else self.validationMessage = validationMessage;
    }, 1)
    return valid;
  }

  onInput(e) {
    if (this.formField && this.formField.fieldOptions && this.formField.fieldOptions.pattern && this.formField.fieldOptions.pattern != 'NameGeneric') {
      var val = e.target.value;
      var testPattern = this.inputValidationService.testPattern(this.formField.fieldOptions.pattern, val, this.formField.fieldOptions);
      if (testPattern.valid) {
        this.validationMessage = null;
      }
      else {
        this.validationMessage = testPattern.msg;
      }
    }
    if (this.historyEnabled) {
      var field = this.formField.fieldOptions && this.formField.fieldOptions.dbField ? this.formField.fieldOptions.dbField : this.formField.field;
      var now = new Date();
      var curDate = moment.utc(`${now.getFullYear()}-${now.getMonth() + 1 < 10 ? '0' : ''}${now.getMonth() + 1}-${now.getDate()} ${now.getHours()}:${now.getMinutes()}`, "YYYY-MM-DD HH:mm Z").toDate().toISOString();
      this.dataObj[field + '__datestamp'] = curDate;
    }
  }
  public getDate(date) {
    return moment.utc(date).format('DD MMM YYYY HH:mm')
  }
  public filterLookupsChange(e) {
    this.searchTextChanged.next(e);
  }

  public filterLookups(search) {
    var self = this;
    var lazyLoad = this.formField.fieldOptions.searchEndPoint;
    if (!lazyLoad && !this.formField.lookups) {
      return;
    }

    if (!search) {
      if (!lazyLoad) {
        this.filteredLookups.next(this.formField.lookups ? this.formField.lookups.filter(bank => !self.formField.fieldOptions.parentFieldId || !bank.cascadeValue || bank.cascadeValue == self.dataObj[self.formField.fieldOptions.parentFieldId]) : []);
        this.dropDownSearching = false;
        return;
      }
      else {
        this.filteredLookups.next(this.formField.lookups ? this.formField.lookups.slice() : []);
        this.dropDownSearching = false;
        return;
      }
    } else {
      search = search.toLowerCase();
    }
    if (this.formField.fieldOptions.searchEndPoint) {
      debugger;
      if (this.formField?.fieldOptions?.extraData?.usePost) {
        if (this.formField.fieldOptions.parentFieldId)
          url = url + "?parentId=" + this.dataObj[this.formField.fieldOptions.parentFieldId];
        this.apiService.post(this.formField.fieldOptions.searchEndPoint.url, { query: search })
          .subscribe(items => {
            var idField = 'id';
            var displayField = 'name';
            var cascadeField = 'parentId';
            if (this.formField.fieldOptions.dataIdField)
              idField = this.formField.fieldOptions.dataIdField;
            if (this.formField.fieldOptions.dataDisplayField)
              displayField = this.formField.fieldOptions.dataDisplayField;
            if (this.formField.fieldOptions.dataCascadeField)
              cascadeField = this.formField.fieldOptions.dataCascadeField;
            this.formField.lookups = items.map(o => { return { value: o[idField], label: o[displayField], data: o, cascadeValue: o[cascadeField], dataItem: o } });
            this.filteredLookups.next(this.formField.lookups)
            this.cdr.detectChanges();

            this.dropDownSearching = false;
          }, error => { });
      }
      else {

        var url = this.formField.fieldOptions.searchEndPoint.url + encodeURIComponent(search);
        if (this.formField.fieldOptions.parentFieldId)
          url = url + "?parentId=" + this.dataObj[this.formField.fieldOptions.parentFieldId];
        this.apiService.get(url)
          .subscribe(items => {
            var idField = 'id';
            var displayField = 'name';
            var cascadeField = 'parentId';
            if (this.formField.fieldOptions.dataIdField)
              idField = this.formField.fieldOptions.dataIdField;
            if (this.formField.fieldOptions.dataDisplayField)
              displayField = this.formField.fieldOptions.dataDisplayField;
            if (this.formField.fieldOptions.dataCascadeField)
              cascadeField = this.formField.fieldOptions.dataCascadeField;
            this.formField.lookups = items.map(o => { return { value: o[idField], label: o[displayField], data: o, cascadeValue: o[cascadeField], dataItem: o } });
            this.filteredLookups.next(this.formField.lookups)
            this.cdr.detectChanges();

            this.dropDownSearching = false;
          }, error => { });
      }
    }
    else {
      console.log('search')
      this.filteredLookups.next(
        this.formField.lookups.filter(bank => (!self.formField.fieldOptions.parentFieldId || !bank.cascadeValue || bank.cascadeValue == self.dataObj[self.formField.fieldOptions.parentFieldId]) && bank.label.toLowerCase().indexOf(search) > -1)
      );

      this.dropDownSearching = false;
    }

  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  public selectOpenChange(e) {
    if (e && this.formField.fieldOptions && this.formField.fieldOptions.parentFieldId) {
      var self = this;
      if (this.formField.lookups)
        this.filteredLookups.next(this.formField.lookups.filter(bank => (!self.formField.fieldOptions.parentFieldId || !bank.cascadeValue || bank.cascadeValue == self.dataObj[self.formField.fieldOptions.parentFieldId])))
    }
  }

  public updateHistoryDate() {
    var self = this;
    let dialogRef = this.dialogService.open(MFCustomDatetimePopupComponent, {
      data: {
        date: self.getDate(self.historyDatestamp)
      },
    });
    dialogRef.afterClosed().subscribe(o => {
      console.log(o)
      if (o)
        self.historyDatestamp = o.toDate().toISOString();
    })
  }

  public actionButton(e) {
    e.stopPropagation();
    var self = this;
    this.formField.fieldOptions.click(self);
  }

  public dropdownSelectionChanged(e) {
    if (this.data == 'otherSelection') {
      this.data = null;
      let dialogRef = this.dialogService.open(MFCustomInputPopupComponent, {
        data: {
          lookupValueGroupId: this.formField?.fieldOptions?.extraData?.lookupValueGroupId
        }
      });
      dialogRef.afterClosed().subscribe(o => {
        console.log(o)
        if (o) {
          this.formField.lookups.push({ value: o.val, label: o.label, cascadeValue: null });
          this.filteredLookups.next(this.formField.lookups);
          this.data = o.val;
        }
      })
    }
  }
  public refreshLookups() {
    if (this._formField && this._formField.lookups) {
      this.filteredLookups.next(this._formField.lookups.slice());
    }
  }
  public get isNestedControlsHidden() {
    if (!this.formField.nestedControls || this.formField.nestedControls.length == 0)
      return true;
    if (_.filter(this.formField.nestedControls, ff => (ff.show ? ff.isShowing : true) && ff.className?.indexOf('mf-nested-yes-no-upload') == 1).length == 0)
      return true;
    return false;
  }
}
